<template>
    <div>
        <el-dropdown trigger="click" class="pc" @command="on_change" popper-style='--el-font-size-base:0.1281rem; top:0.4rem'>
            <span class="el-dropdown-link">
              {{value}}
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item
                        v-for="item in options"
                        :key="item.value"
                        :command="item">
                        {{item.label}}
                    </el-dropdown-item>
              </el-dropdown-menu>
            </template>
        </el-dropdown>
    
        <el-dropdown trigger="click" class="mobile" @command="on_change" popper-style='--el-font-size-base:3vw; top:7.4vw'>
            <span class="el-dropdown-link">
              {{value}}
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item
                        v-for="item in options"
                        :key="item.value"
                        :command="item">
                        {{item.label}}
                    </el-dropdown-item>
              </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>

</template>


<script>
    import { ElDropdown } from 'element-plus'
    import { ElDropdownItem } from 'element-plus'
    import { ElDropdownMenu } from 'element-plus'
    import { ElIcon } from 'element-plus'

    import { mapMutations } from "vuex"
    import { useI18n } from "vue-i18n"
    import { ref } from "vue"
    import { ArrowDown } from '@element-plus/icons-vue'

    export default {
        setup() {
            let $i18n = useI18n({ useScope: 'global' })
            let options = [{
                    value: 'en',
                    label: 'English',
                },
                {
                    value: 'zh_CN',
                    label: '简体中文',
                },
                {
                    value: 'zh_HK',
                    label: '香港繁體',
                },
                {
                    value: 'zh_TW',
                    label: '臺灣正體',
                }]
            const get_language=() => {
                let language = localStorage.getItem("language")
                for (const item of options){
                    if (item.value === language) {
                        return item.label
                    }
                }
            }
            let value = ref(get_language())
            return {
                $i18n,
                options,
                value
            }
        },
        methods: {
            ...mapMutations(["set_language"]),
            ...mapMutations(["set_margin_bottom_pc"]),
            ...mapMutations(["set_margin_bottom_mobile"]),
            ...mapMutations(["set_margin_bottom_pad"]),

            set_margin_bottom(language) {
                if (language === 'en') {
                    this.set_margin_bottom_pc("0.17rem");
                    this.set_margin_bottom_mobile('2.6vw');
                    this.set_margin_bottom_pad('1.6vw');
                } else {
                    this.set_margin_bottom_pc("0.2rem");
                    this.set_margin_bottom_mobile('3vw');
                    this.set_margin_bottom_pad('2vw');
                }
            },

            on_change(item) {
                /*
                console.log("new_locale=" + new_locale)
                console.log("language=" + this.language)
                console.log("this.$i18n.locale1=" + this.$i18n.locale)
                */
                this.$i18n.locale = item.value
                /*
                console.log("this.$i18n.locale2=" + this.$i18n.locale)
                */
                this.set_language(item.value)
                this.value=item.label
                this.set_margin_bottom(item.value)
                this.$router.go(0)
            },

        },
        components: {
            ElDropdown,
            ElDropdownMenu,
            ElDropdownItem,
            ElIcon,
            ArrowDown,
        },
        mounted() {
            this.set_margin_bottom(localStorage.getItem("language"))
        }
    }

</script>


<style scoped>

    .el-dropdown-link {
        cursor: pointer;
        color: black!important;
        font-size: var(--el-menu-item-font-size);
        display: flex;
        align-items: center;
        top: 0;
    }

    @media screen and (max-width: 768px){
        .pc {
            display:none
        }
        .el-dropdown-link {
            --el-menu-item-font-size: 3vw;
        }

        .mobile {
            border:1px solid rgb(197, 197, 197);
            padding: 1.5vw 1vw;
            width: 17.6vw;
        }

    }

    @media screen and (max-width: 1080px) and (min-width: 768px) {
        .pc {
            display:none
        }
        .el-dropdown-link {
            --el-menu-item-font-size: 3vw;
        }
        .mobile {
            border:1px solid rgb(197, 197, 197);
            padding: 1.215vw 1vw;
            width: 15.8vw;
        }

    }

    @media screen and (min-width: 1080px) {
        .mobile {
            display:none
        }
        .pc {
            border:1px solid rgb(197, 197, 197);
            padding: 0.135rem 0.05rem;
        }
        .el-dropdown-link {
            --el-menu-item-font-size: 0.1281rem;
        }
    }

</style>